import { createAsyncThunk } from '@reduxjs/toolkit';
import { toApiError } from 'shared/errors';
import mainPageRepository from 'modules/main/domain/repositories/main-page.repository';
import type { StatisticResponseDto } from 'modules/main/domain/types/response-dto';
import { RootState } from 'store/store';

const PREFIX = 'mainPage';

export const fetchMainPageInfo = createAsyncThunk<StatisticResponseDto, { tournamentId: number }>(
  `${PREFIX}/fetchChampionships`,
  async (payload, { rejectWithValue }) => {
    try {
      return await mainPageRepository.getStatistics(payload.tournamentId);
    } catch (error) {
      console.error(`${PREFIX}/fetchChampionships error:`, error);

      return rejectWithValue(toApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      // защита только от параллельных запросов — данные обновляются при каждом заходе на дашборд
      const { status } = (getState() as RootState).mainPage;
      return !status.loading && !status.refreshing;
    },
  },
);
